export interface IHoverable {
  isHover?: boolean;
}
